import { Instagram } from "lucide-react";
import { LantixMark, Spark } from "./Logo";
import { scrollToId } from "@/lib/scrollTo";

const NAV = [
  { label: "Discover", href: "#discovery" },
  { label: "Experience", href: "#experience" },
  { label: "Versus Legacy", href: "#versus" },
  { label: "Lantix Pro", href: "#pro" },
  { label: "Investors", href: "#investors" },
];

const CONTACT = [
  { label: "hello@lantixapp.com", href: "mailto:hello@lantixapp.com" },
  { label: "invest@lantixapp.com", href: "mailto:invest@lantixapp.com" },
  { label: "@lantixapp", href: "https://www.instagram.com/lantixapp" },
  { label: "lantixapp.com", href: "https://lantixapp.com" },
];

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/lantixapp", icon: Instagram },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-brand-purple/15 bg-black">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <LantixMark size={34} />
              <span className="font-brand font-bold tracking-[0.14em] text-lg text-brand-paper">
                LANTIX
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-brand-mist/60">
              Discover what to do, who to go with, and how to get in. A behavioral layer for live
              experiences, connecting people to the moments that matter most.
            </p>
            <p className="mt-6 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-brand-mist/45">
              <Spark className="h-3.5 w-3.5 text-brand-gold/70" /> A venture by True Life
              Entertainment, Inc.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Lantix on ${s.label}`}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-brand-purple/30 bg-white/5 text-brand-mist/70 transition-all duration-300 hover:border-brand-purple hover:bg-brand-purple/20 hover:text-brand-paper hover:shadow-[0_0_24px_rgba(140,82,255,0.5)]"
                >
                  <s.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-gold">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.href}>
                  <button
                    type="button"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={() => scrollToId(l.href)}
                    className="text-sm text-brand-mist/65 transition-colors duration-300 hover:text-brand-teal"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-gold">Contact</p>
            <ul className="mt-5 space-y-3">
              {CONTACT.map((c) => (
                <li key={c.label}>
                  <a
                    href={c.href}
                    target={c.href.startsWith("http") ? "_blank" : undefined}
                    rel={c.href.startsWith("http") ? "noopener noreferrer" : undefined}
                    data-testid={`footer-contact-${c.label.replace(/[^a-z]/gi, "-").toLowerCase()}`}
                    className="text-sm text-brand-mist/65 transition-colors duration-300 hover:text-brand-teal"
                  >
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-brand-purple/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-brand-mist/45">
            © True Life Entertainment, Inc. All rights reserved.
          </p>
          <p className="text-xs uppercase tracking-[0.2em] text-brand-mist/40">
            Built for Boston
          </p>
        </div>
      </div>
    </footer>
  );
}
